import React, { Dispatch, SetStateAction } from "react";
import { Form, Pagination } from "antd";

import { Styled } from "./style";
import useResponsive from "hook/useResponsive";
import SimplePagination from "component/SimplePagination";

interface Props {
  total: number;
  current: number;
  perPage: number;
  setCurrent: Dispatch<SetStateAction<number>>;
  setPerPage: Dispatch<SetStateAction<number>>;
  pageSizeOptions: number[];
}
const CustomPagination: React.FC<Props> = ({
  total,
  current,
  perPage,
  setCurrent,
  setPerPage,
}) => {
  const { isMobile } = useResponsive();
  const [form] = Form.useForm();
  // for mobile
  const handleSubmitPagination = (value: { per: number; page: number }) => {
    setCurrent(value.page);
    setPerPage(value.per);
  };
  if(!total) return <></>
  return (
    <Styled className="flex justify-end mb-4">
      {isMobile ? (
        <Form form={form} onFinish={handleSubmitPagination}>
          <SimplePagination
            pageInit={current}
            total={total}
            form={form}
            perInit={perPage}
          />
        </Form>
      ) : (
        <Pagination
          showQuickJumper
          current={current}
          total={total}
          showTotal={(total, range) =>
            `${range[0]} ~ ${range[1]}件(全${total}件中)`
          }
          showSizeChanger
          onChange={(page) => {
            setCurrent(page);
            form.setFieldsValue({
              page,
            });
          }}
          onShowSizeChange={(page: number, size: number) => {
            setCurrent(page);
            setPerPage(size);
            form.setFieldsValue({
              per: size,
              page,
            });
          }}
          pageSize={perPage}
          pageSizeOptions={[10, 20, 50, 100]}
        />
      )}
    </Styled>
  );
};

export default CustomPagination;
